var App = App || {};

App.MobileTable = (function ($) {
    'use strict';

    function generateMobileTables() {
        const $originalTable = $('.service-table');
        const $responsiveContainer = $('.service-table-mobile');
        $responsiveContainer.empty();

        if (window.innerWidth < 768) {
            const $headings = $originalTable.find('thead th').not(':first-child');
            const $rows = $originalTable.find('tbody tr');

            $headings.each(function (index) {
                const $newTable = $('<table class="mobile-table"></table>');
                const $newThead = $('<thead></thead>');
                const $newTbody = $('<tbody></tbody>');

                const headingHtml = $(this).html();
                const $newHeadingRow = $(`<tr><th scope="col" colspan="2">${headingHtml}</th></tr>`);
                $newThead.append($newHeadingRow);

                $rows.each(function () {
                    const $originalRow = $(this);
                    const $labelCell = $originalRow.find('th').clone();
                    const $dataCell = $originalRow.find(`td:eq(${index})`).clone();

                    const availabilityText = $dataCell.text().trim();

                    // Check for 'Available until' status
                    if (availabilityText.includes("until")) {
                        $dataCell.addClass('available-until');
                        const $statusDiv = $('<div class="available-until"></div>');
                        const $dot = $('<div class="dot">&nbsp;</div>');
                        $statusDiv.append($dot).append(availabilityText);
                        $dataCell.empty().append($statusDiv);
                    }
                    // Check for 'Available' status
                    else if (availabilityText.includes("Available")) {
                        $dataCell.addClass('available');
                        const $statusDiv = $('<div class="available"></div>');
                        const $dot = $('<div class="dot">&nbsp;</div>');
                        $statusDiv.append($dot).append(availabilityText);
                        $dataCell.empty().append($statusDiv);
                    }
                    // Check for 'Unavailable' status
                    else if (availabilityText.includes("Unavailable")) {
                        $dataCell.addClass('unavailable');
                        const $statusDiv = $('<div class="unavailable"></div>');
                        const $dot = $('<div class="dot">&nbsp;</div>');
                        $statusDiv.append($dot).append(availabilityText);
                        $dataCell.empty().append($statusDiv);
                    }

                    const $newRow = $('<tr></tr>');
                    $newRow.append($labelCell).append($dataCell);
                    $newTbody.append($newRow);
                });

                $newTable.append($newThead).append($newTbody);
                $responsiveContainer.append($newTable);
            });
        } else {
            const $rows = $originalTable.find('tbody tr');

            $rows.each(function () {
                const $row = $(this);
                $row.find('td').each(function () {
                    const $cell = $(this);
                    const availabilityText = $cell.text().trim();

                    if (availabilityText.includes("until")) {
                        $cell.addClass('available-until');
                        const $statusDiv = $('<div class="available-until"></div>');
                        const $dot = $('<div class="dot">&nbsp;</div>');
                        $statusDiv.append($dot).append(availabilityText);
                        $cell.empty().append($statusDiv);
                    }

                    else if (availabilityText.includes("Available")) {
                        $cell.addClass('available');
                        const $statusDiv = $('<div class="available"></div>');
                        const $dot = $('<div class="dot">&nbsp;</div>');
                        $statusDiv.append($dot).append(availabilityText);
                        $cell.empty().append($statusDiv);
                    }

                    else if (availabilityText.includes("Unavailable")) {
                        $cell.addClass('unavailable');
                        const $statusDiv = $('<div class="unavailable"></div>');
                        const $dot = $('<div class="dot">&nbsp;</div>');
                        $statusDiv.append($dot).append(availabilityText);
                        $cell.empty().append($statusDiv);
                    }
                });
            });
        }
    }

    function init() {
        generateMobileTables();

        $(window).on('resize', function () {
            generateMobileTables();
        });
    }

    return {
        init: init
    };

})(jQuery);

$(document).ready(function () {
    App.MobileTable.init();
});
